export default "__VITE_ASSET__BAjTjsrG__"